import styled from "styled-components";
import { Heading } from "../../common/Heading/Heading";
import { useTranslation } from "react-i18next";
import { media } from "../../../styles/mixins";
import { Solution } from "./Solution/Solution";
import { FullWidthSectionWithContent } from "../../common/FullWidthSectionWithContent";
import { AmocrmDemo } from "../../../assets/images/AmocrmDemo";
import { UseDeskDemo } from "../../../assets/images/UseDeskDemo";
import { HelpDeskEddyDemo } from "../../../assets/images/HelpDeskEddyDemo";
import { AmocrmStyleDemo } from "../../../assets/images/AmocrmStyleDemo";
import { UseDeskStyleDemo } from "../../../assets/images/UseDeskStyleDemo";
import { HelpDeskEddyStyleDemo } from "../../../assets/images/HelpDeskEddyStyleDemo";
import { ContextDemo } from "../../../assets/images/ContextDemo";
import { SlaDemo } from "../../../assets/images/SlaDemo";
import { ToolsDemo } from "../../../assets/images/ToolsDemo";

export const Solutions = ({ activeCrm }) => {
  const { t } = useTranslation();

  const getSolutionImages = () => {
    return [
      {
        AmoCRM: <AmocrmDemo />,
        UseDesk: <UseDeskDemo />,
        HelpDeskEddy: <HelpDeskEddyDemo />,
      },
      <ContextDemo />,
      <SlaDemo />,
      {
        AmoCRM: <AmocrmStyleDemo />,
        UseDesk: <UseDeskStyleDemo />,
        HelpDeskEddy: <HelpDeskEddyStyleDemo />,
      },
      <ToolsDemo />,
    ];
  };

  return (
    <FullWidthSectionWithContent id="about">
      <Title>
        <Heading size={1} text={t("solutions.title")} />
      </Title>
      <SolutionsContainer>
        {getSolutionImages().map((image, index) => {
          return (
            <Solution
              image={image}
              index={index}
              key={`solution-${index}`}
              activeCrm={activeCrm}
            />
          );
        })}
      </SolutionsContainer>
    </FullWidthSectionWithContent>
  );
};

const SolutionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 37px;
  margin-bottom: 32px;
  gap: 40px;

  ${media.tablet(`
    margin-top: 58px;
     margin-bottom: 40px;
     gap: 80px;
  `)}

  ${media.laptop(`
    margin-top: 80px;
    margin-bottom: 70px;
    gap: 128px;
  `)}
`;

const Title = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 32px;

  ${media.tablet(`
   
     margin-bottom: 40px;
  `)}

  ${media.laptop(`
   
    margin-bottom: 70px;
  `)}
`;
